import { useQueryClient } from '@tanstack/react-query';
import { RefObject, useEffect } from 'react';
import useCustomize from '@/common/hooks/useCustomize';
import { startBookingDwellPrefetch } from '@/modules/profile/functions/bookingDwellPrefetch';
import { preloadProfileAsideCode } from '@/modules/profile/functions/preloadProfileAsideCode';
import { prefetchBookingPieces } from '@/modules/profile/hooks/useProgressiveProfile';

/**
 * Prefetches a doctor's booking card data, and the profile aside's code, when the patient pauses on
 * their card in `rootRef` (see `startBookingDwellPrefetch`). `resetKey` starts a fresh budget.
 */
export function useBookingDwellPrefetch(rootRef: RefObject<HTMLElement>, enabled: boolean, resetKey: string) {
  const queryClient = useQueryClient();
  const university = useCustomize(state => state.customize?.partnerKey) || undefined;

  useEffect(() => {
    const root = rootRef.current;
    if (!enabled || !root) return;
    return startBookingDwellPrefetch(root, slug => {
      prefetchBookingPieces(queryClient, slug, university);
      preloadProfileAsideCode();
    });
  }, [rootRef, enabled, resetKey, queryClient, university]);
}
